import {reactive} from "vue";

class UsuarioColaboradorEvents {

    listenerUsuarioGravado = reactive(({value: {codigoUsuario: ""}}))
    listenerUsuarioAlterado = reactive(({value: {codigoUsuario: ""}}))
    listenerUsuarioAtivado = reactive(({value: {codigoUsuario: ""}}))
    listenerUsuarioDesativado = reactive(({value: {codigoUsuario: ""}}))
    listenerUsuarioSessaoEncerrada = reactive(({value: {codigoSessao: ""}}))
    listenerUsuarioColaboradorAdicionado = reactive(({value: {codigoUsuario: ""}}))

    emitUsuarioGravado(codigoUsuario: any) {
        this.listenerUsuarioGravado.value = {codigoUsuario: codigoUsuario}
    }

    emitUsuarioAlterado(codigoUsuario: any) {
        this.listenerUsuarioAlterado.value = {codigoUsuario: codigoUsuario}
    }

    emitUsuarioAtivado(codigoUsuario: any) {
        this.listenerUsuarioAtivado.value = {codigoUsuario: codigoUsuario}
    }

    emitUsuarioDesativado(codigoUsuario: any) {
        this.listenerUsuarioDesativado.value = {codigoUsuario: codigoUsuario}
    }

    emitUsuarioSessaoEncerrada(codigoSessao: any) {
        this.listenerUsuarioSessaoEncerrada.value = {codigoSessao: codigoSessao}
    }

    emitUsuarioColaboradorAdicionado(codigoUsuario: any) {
        this.listenerUsuarioColaboradorAdicionado.value = {codigoUsuario: codigoUsuario}
    }

}

export default UsuarioColaboradorEvents;